export const home = {
    tabs: {
        home: 'Home',
        homeAccessibility: 'Início',
        transactions: 'Transações',
        analysis: 'Análise',
        cashFlow: 'Fluxo de caixa',
        more: 'Mais',
    },
    balance: {
        monthResult: 'Resultado do mês',
        projectedAvailable: 'Disponível previsto',
        available: 'Disponível',
        projected: 'Saldo previsto',
        historical: 'Saldo no fim do mês',
        historicalAvailable: 'Disponível no fim do mês',
        // Início do mês ≠ 1 (ADR 0190): não existe "o mês" pra nomear.
        historicalPeriod: 'Saldo no fim do período',
        historicalAvailablePeriod: 'Disponível no fim do período',
        total: 'Saldo total',
        hidden: 'R$ ••••',
        allExcluded: 'Todas as contas estão fora do saldo total',
        seeAccounts: 'Ver contas',
        loading: 'Carregando o saldo',
    },
    // Nuvem ao lado do mês quando a sincronização entre aparelhos parou (ADR 0146). Só existe em falha.
    syncStalled: {
        a11y: 'A sincronização entre aparelhos parou. Toque para ver o motivo no Backup.',
    },
    // Checklist guiado (spec "Home: checklist guiado", set/2026): um passo aberto por vez,
    // com o PORQUÊ e um único botão; os outros só como rótulo.
    firstSteps: {
        title: 'Vamos começar',
        titleOneLeft: 'Falta só um passo',
        progress: '{{done}} de {{total}} concluídos',
        createAccount: 'Criar conta bancária',
        // "Cadastrar cartão" falava do formulário; o rótulo agora fala do ganho.
        addCard: 'Acompanhar seu cartão',
        addTransaction: 'Registrar o primeiro gasto',
        // 3º passo por caminho (ADR 0071) + leitura automática no Android pt-BR.
        createBudget: 'Criar seu primeiro orçamento',
        createGoal: 'Criar sua primeira meta',
        enableListener: 'Ligar leitura automática',
        why: {
            account: 'Toda conta que você usa entra aqui. Aí o saldo do app passa a ser o saldo do seu bolso.',
            transaction: 'Um gasto de hoje já basta. É a partir dele que o Kontto mostra pra onde vai seu dinheiro.',
            card: 'Cada compra entra na fatura certa e você vê quanto do mês já está comprometido antes de ela chegar.',
            budget: 'Você diz quanto pode gastar na categoria que mais pesa e o Kontto avisa antes de estourar.',
            goal: 'A cada depósito você vê quanto falta. Guardar com objetivo é o que faz sobrar no fim do mês.',
            listener: 'O Kontto lê a notificação de compra do seu banco e lança o gasto sozinho. Você só confere.',
        },
        action: {
            account: 'Criar conta',
            transaction: 'Adicionar gasto',
            card: 'Adicionar cartão',
            budget: 'Criar orçamento',
            goal: 'Criar meta',
            listener: 'Ligar leitura automática',
        },
        // Saída do passo atual, na voz de quem recusa. Todo passo tem a sua; quem não tiver
        // texto próprio (conta e 1º gasto, que já vêm do wizard) cai no "Pular" genérico.
        skipCard: 'Não uso cartão de crédito',
        skipListener: 'Não quero leitura automática',
        skipBudget: 'Não quero orçamento agora',
        skipGoal: 'Não tenho uma meta agora',
        dismiss: 'Ocultar',
        skip: 'Pular',
    },
    activation: {
        title: 'Registre seu primeiro gasto',
        subtitle: 'Comece com algo que você gastou hoje. Leva 10 segundos e seu Kontto ganha vida.',
        button: 'Adicionar gasto',
    },
    // Card de lembretes (Android, após o 1º gasto) — substituiu o prompt nativo do cold
    // launch (auditoria de onboarding, A4). Uma linha de contexto e saída honesta.
    secondEntry: {
        // Mesmo pedido da notificação do D+1 (reminders.secondEntry). Sem "ontem": o card
        // fica devido a partir do dia seguinte, mas pode aparecer dias depois.
        title: 'Não pare no primeiro gasto',
        subtitle: 'Anote o de hoje e seu dinheiro começa a se organizar.',
        action: 'Anotar gasto',
        later: 'Agora não',
    },
    // Reconvite da leitura automática (lib/listenerReinvite.ts): 7+ dias, 10+ lançamentos, leitura desligada.
    listenerReinvite: {
        title_one: 'Você já fez {{count}} lançamento',
        title_other: 'Você já fez {{count}} lançamentos',
        subtitle: 'Os próximos podem entrar sozinhos, pelas notificações do seu banco.',
        enable: 'Ligar leitura',
        later: 'Agora não',
    },
    reminders: {
        title: 'Não deixe nenhuma conta vencer',
        subtitle: 'Avisamos no dia de cada conta e fatura — sem juros por esquecimento. Dá pra ajustar ou desligar em Ajustes › Lembretes.',
        enable: 'Ativar lembretes',
        later: 'Agora não',
        grantedToast: 'Lembretes ativados',
        deniedToast: 'Tudo bem — dá pra ligar depois em Ajustes › Lembretes.',
    },
    proUpsell: {
        backupTitle: 'Perdeu o celular, perdeu seu histórico?',
        backupSubtitleCount: 'Proteja seus {{total}} lançamentos',
        backupSubtitleDefault: 'Ative o backup automático e cifrado',
        backupCta: 'Ativar',
        syncTitle: 'Use o Kontto no celular e no tablet',
        syncSubtitle: 'Sincronização cifrada de ponta a ponta',
        syncCta: 'Ligar',
        bellTitle: 'Netflix, Spotify e cia vão cobrar amanhã?',
        bellSubtitle: 'Avisamos 1 dia antes pra cancelar a tempo',
        bellCta: 'Ligar',
        trialSuffix: '{{subtitle}} · {{label}} grátis',
        accessibility: '{{title}}. {{subtitle}}',
        dismiss: 'Dispensar',
    },
    // Faixa FIXA de conversão abaixo do saldo (design "Oferta Trial - Implementação"):
    // mensagem persistente pra virar pagador, escolhida pelo histórico do usuário
    // (nunca testou / testou e não seguiu / já foi assinante).
    proConversion: {
        messageNeverTrial: 'Conheça o Kontto Pro · {{label}} grátis',
        messageNever: 'Conheça o Kontto Pro',
        messageChurned: 'Volte a ser Kontto Pro',
        messageTrialed: 'Gostou do teste? Assine o Pro',
        accessibilityHint: 'Abrir os planos do Kontto Pro',
    },
    billingIssue: {
        // Pro na carência da loja: a cobrança falhou, o acesso segue até a loja desistir.
        // Fato + saída; nunca ameaça. A loja é quem cobra — o app só leva até ela.
        title: 'Não conseguimos cobrar seu Kontto Pro',
        body: 'Atualize a forma de pagamento na {{store}} para continuar com o Pro.',
        action: 'Atualizar pagamento',
        accessibilityHint: 'Abrir a assinatura na {{store}}',
    },
    setupToast: {
        title: 'Tudo pronto! 🎉',
        message: 'O Kontto já está configurado — é só começar a usar.',
    },
    flow: {
        income: 'Receitas',
        expenses: 'Despesas',
    },
    insights: {
        sectionTitle: 'Sugestões do mês',
        empty: 'Sem sugestões por enquanto. Registre alguns gastos para ver dicas aqui.',
    },
    shortcuts: {
        sectionTitle: 'Atalhos',
        items: {
            accounts: 'Contas',
            cards: 'Cartões',
            categories: 'Categorias',
            budget: 'Orçamento',
            goals: 'Metas',
            subscriptions: 'Recorrências',
            financings: 'Financiamentos',
            loans: 'Empréstimos',
            personalLoans: 'Quem me deve',
            projections: 'Projeções',
            reports: 'Relatórios',
            cashFlow: 'Fluxo de caixa',
            advancedReports: 'Rel. avançados',
            ai: 'Assistente IA',
            receipts: 'Importar nota',
        },
    },
    pending: {
        sectionTitle: 'Pendências',
        pay: 'Pagar',
        receive: 'Receber',
        invoices: 'Faturas',
        transfers: 'Transferências agendadas',
    },
    accounts: {
        sectionTitle: 'Contas',
        addAccount: 'Adicionar conta',
        available: 'Disponível',
        total: 'Total',
        reserved: 'Reservado',
        projected: 'Previsto',
        // Fatura de cartão sem conta pagadora (ADR 0135): linha própria, soma no Previsto.
        unassignedInvoice_one: 'Fatura sem conta pagadora',
        unassignedInvoice_other: 'Faturas sem conta pagadora',
        unassignedInvoiceCards_one: '{{count}} cartão',
        unassignedInvoiceCards_other: '{{count}} cartões',
        unassignedInvoiceA11y_one: 'Fatura sem conta pagadora, {{detail}}, {{amount}}. Escolher a conta que paga',
        unassignedInvoiceA11y_other: 'Faturas sem conta pagadora, {{detail}}, {{amount}}. Escolher a conta que paga',
    },
    cards: {
        sectionTitle: 'Cartões',
        addCard: 'Adicionar cartão',
        closing: 'Fechamento',
        total: 'Total',
        upcoming: 'Próxima',
    },
    // Seção opt-in "Parcelamentos" (ADR 0166): só três coisas — quanto pesa por mês, o
    // próximo alívio e quando fica livre. Altura fixa com 2 ou com 20 compras.
    installments: {
        sectionTitle: 'Parcelamentos',
        perMonth: 'Por mês',
        hiddenAmount: '••••',
        incomeShare: '{{share}} da renda',
        purchases_one: '{{count}} compra',
        purchases_other: '{{count}} compras',
        inSources_one: 'em {{count}} cartão ou conta',
        inSources_other: 'em {{count}} cartões/contas',
        reliefTitle: '{{name}} termina',
        reliefSubtitle: 'próximo alívio · {{month}}',
        freeTitle: 'Livre de parcelas em {{month}}',
        freeSubtitle: 'última parcela: {{name}}',
        emptyTitle: 'Nenhuma parcela em aberto',
        emptySubtitle: 'Simule antes de parcelar a próxima',
        emptyAccessibility: 'Simular uma compra parcelada',
        cardAccessibility: 'Abrir Parcelamentos',
    },
    // Seção opt-in "Quem me deve": as N pessoas mais urgentes com nome e TODO o resto
    // numa linha agregada — teto duro de altura pra quem tem dezenas de empréstimos.
    receivables: {
        sectionTitle: 'Quem me deve',
        hiddenAmount: '••••',
        rowAccessibility: 'Quem me deve: {{name}}',
        overdueDays_one: 'Atrasado há {{count}} dia',
        overdueDays_other: 'Atrasado há {{count}} dias',
        agreedFor: 'Combinado p/ {{date}}',
        whenPossible: 'Quando der',
        loanCount_one: '{{count}} valor a receber',
        loanCount_other: '{{count}} valores a receber',
        // A linha agregada. A composição não fala em mês de propósito — o recorte do
        // mês vive no rodapé, ver ADR 0104.
        restPeople_one: 'Mais {{count}} pessoa',
        restPeople_other: 'Mais {{count}} pessoas',
        restAccessibility: 'Ver todos os empréstimos',
        restOverdue_one: '{{count}} atrasada',
        restOverdue_other: '{{count}} atrasadas',
        restScheduled_one: '{{count}} com data',
        restScheduled_other: '{{count}} com data',
        restWhenPossible: '{{count}} quando der',
        // Rodapé: só um dos dois aparece, e nenhum quando não há o que dizer.
        footnotePending: '{{amount}} já contam nas Pendências de {{month}}',
        footnotePendingPeriod: '{{amount}} já contam nas Pendências deste período',
        footnoteInBalance: 'Já somado ao seu saldo',
        emptyTitle: 'Emprestou dinheiro?',
        emptySubtitle: 'Anote aqui e acompanhe quem já te pagou',
        createAccessibility: 'Registrar empréstimo a alguém',
    },
    recent: {
        sectionTitle: 'Despesas recentes',
        installmentBadge: '{{total}}x',
    },
    budget: {
        sectionTitle: 'Orçamento',
        empty: 'Nenhum orçamento definido. Toque para criar.',
    },
    // Seção opt-in "Metas de receita" (orçamentos type='income', ADR 0046).
    incomeGoals: {
        sectionTitle: 'Metas de receita',
        empty: 'Nenhuma meta de receita. Toque para criar.',
        // Card único da Home (ADR 0159): linha por meta + rodapé com o total.
        progress: '{{received}} de {{target}}',
        percent: '{{pct}}%',
        received: 'Recebido',
        target: 'Meta',
    },
    goals: {
        sectionTitle: 'Metas',
        saved: 'Guardado',
        target: 'Meta',
        empty: 'Nenhuma meta ainda. Toque para criar.',
    },
    reservas: {
        sectionTitle: 'Caixinhas',
        rowAccessibility: 'Caixinha {{name}}',
        accountFallback: 'Conta',
        percentSuffix: ' · {{pct}}%',
        noTargetSuffix: ' · sem meta',
        hiddenAmount: '••••',
        ofTarget: 'de {{amount}}',
        saved: 'guardado',
        createAccessibility: 'Criar caixinha',
        emptyTitle: 'Crie uma caixinha',
        emptySubtitle: 'Reserve dinheiro dentro de uma conta sem mexer no saldo.',
    },
    subscriptions: {
        sectionTitle: 'Recorrências',
        monthlySpending: 'Gasto mensal',
        noneActive: 'Nenhuma assinatura ativa',
        activeCount_one: '{{count}} assinatura ativa',
        activeCount_other: '{{count}} assinaturas ativas',
    },
    manageHome: 'Gerenciar tela inicial',
    analysis: {
        title: 'Análise',
        viewModes: {
            commitments: 'No mês',
            new: 'Novos gastos',
        },
        overview: {
            title: 'Balanço do mês',
            income: 'Receitas',
            expenses: 'Despesas',
            balance: 'Balanço',
            expensesSameLevel: 'Despesas no mesmo nível do mês passado',
            expensesDelta: 'Despesas {{percent}} vs mês anterior',
        },
        newOverview: {
            title: 'Novos gastos do mês',
            categories: 'Categorias',
            average: 'Média',
            topCategory: 'Maior peso',
            noHighlight: 'Sem destaque',
            infoAccessibility: 'O que são novos gastos?',
            infoTitle: 'O que entra em "Novos gastos"?',
            infoBody: 'Só o gasto que ENTROU na sua vida financeira neste mês: compras avulsas feitas neste período e a primeira ocorrência de uma recorrência nova, mesmo que ainda projetada. Parcelamento novo entra com o valor total da compra, de uma vez, no mês da compra.',
            infoBodyContrast: 'Recorrências antigas, parcelas que já vinham de meses anteriores e parcelas de financiamento ficam de fora — elas continuam na visão "No mês". Compra antiga lançada ou importada agora conta no mês em que foi feita; gasto agendado para frente conta no mês em que você o lançou. Use pra responder: "que gasto novo eu assumi agora?"',
        },
        categoryRow: {
            collapseSubcategories: 'Recolher subcategorias',
            expandSubcategories: 'Ver subcategorias',
            loading: 'Carregando…',
            emptySubcategories: 'Sem lançamentos para detalhar.',
            subcategoryShare: '{{percent}}% da categoria',
        },
        typeSelector: {
            expenses: 'Despesas',
            income: 'Receitas',
            accessibility: 'Tipo do gráfico: {{label}}. Toque para trocar',
        },
        breakdown: {
            others: 'Outros',
            expenseTitle: 'Despesas por categoria',
            incomeTitle: 'Receitas por categoria',
            newTitle: 'Novos gastos por categoria',
            expenseSubtitle: 'Visão detalhada do seu fluxo de caixa',
            incomeSubtitle: 'De onde vieram as entradas do mês',
            newSubtitle: 'Onde os gastos novos começaram a pesar',
            expenseEmptyTitle: 'Nada relevante para ler neste recorte',
            incomeEmptyTitle: 'Nenhuma receita neste mês',
            newEmptyTitle: 'Nenhum gasto novo neste mês',
            expenseEmptySubtitle: 'Quando houver receitas, despesas ou categorias com movimento, a leitura por categoria aparece aqui.',
            incomeEmptySubtitle: 'Quando houver receitas no mês — lançadas ou recorrentes —, a leitura por categoria aparece aqui.',
            newEmptySubtitle: 'Se os gastos do período vieram de parcelas antigas ou ainda não houve novas saídas, este bloco fica vazio por enquanto.',
            totalSpent: 'Total gasto',
            totalReceived: 'Total recebido',
        },
        empty: {
            title: 'A análise precisa de mais movimento',
            subtitle: 'Assim que houver transações, categorias ou histórico suficiente, esta tela começa a mostrar tendência, composição e próximos passos.',
            action: 'Abrir transações',
        },
        monthlyFlow: {
            sectionTitle: 'Fluxo mensal',
            lastMonths: 'Últimos {{months}} meses',
            income: 'Receitas',
            expenses: 'Despesas',
            emptyTitle: 'Ainda sem histórico suficiente',
            emptySubtitle: 'Quando o app acumular alguns meses de movimento confirmado, este gráfico passa a mostrar a evolução de receitas e despesas.',
        },
        netWorth: {
            sectionTitle: 'Patrimônio',
            monthsValue: '{{months}} meses',
            totalBalance: 'Saldo total',
            emptyTitle: 'Patrimônio ainda sem série histórica',
            emptySubtitle: 'Conforme contas e movimentações forem sendo usadas ao longo do tempo, esta curva começa a mostrar a evolução do saldo total.',
        },
        addMovement: 'Adicionar movimentação',
        reportsLink: {
            title: 'Relatórios avançados',
            subtitle: 'Fixas vs variáveis, comparativo, fluxo de caixa e PDF',
        },
        weekday: {
            sectionTitle: 'Gastos por dia da semana',
        },
        fixedVariable: {
            sectionTitle: 'Fixas e variáveis',
        },
        spendingPace: {
            sectionTitle: 'Ritmo de gasto',
            legendCurrent: 'Este mês',
            legendPrevious: 'Mês anterior',
            sameDay: 'vs mesmo dia',
        },
        topExpenses: {
            sectionTitle: 'Maiores gastos',
            noDescription: 'Sem descrição',
            empty: 'Nenhuma despesa no mês ainda.',
        },
        savingsRate: {
            sectionTitle: 'Taxa de poupança',
            explainer: 'Parte da renda que sobrou em cada mês.',
        },
        manageLayout: 'Personalizar análise',
    },
    more: {
        title: 'Mais',
        settingsAccessibility: 'Configurações',
        proBadge: 'Pro',
        sections: {
            organize: 'Organizar',
            plan: 'Planejar',
            track: 'Acompanhar',
            analyze: 'Analisar',
            tools: 'Ferramentas',
        },
        items: {
            accounts: 'Contas',
            creditCards: 'Cartões de Crédito',
            categories: 'Categorias',
            tags: 'Tags',
            budget: 'Orçamento',
            goals: 'Metas e Caixinhas',
            projections: 'Projeções',
            subscriptions: 'Recorrências',
            financings: 'Financiamentos',
            loans: 'Empréstimos',
            personalLoans: 'Quem me deve',
            installments: 'Parcelamentos',
            customReport: 'Relatório personalizado',
            advancedReports: 'Relatórios avançados',
            aiAssistant: 'Assistente IA',
            importReceipt: 'Importar comprovante',
            importCsv: 'Importar e exportar',
        },
    },
};
